import React from 'react';
import styled from 'styled-components';
import SecondaryButton from './SecondaryButton';

const SecondaryIconButton = styled(({ icon, children, ...props }) => (
  <SecondaryButton {...props}>
    {icon}
    {children}
  </SecondaryButton>
))`
  svg {
    width: 18px;
    height: 18px;

    margin-right: 2px;
  }
`;

export default SecondaryIconButton;
